// extracted by mini-css-extract-plugin
module.exports = {"faqContentBox":"highlightBlock_faqContentBox__87x5k","contentTitle":"highlightBlock_contentTitle___3hf7"};